import TabCustomerFiles from './TabCustomerFiles';

export default TabCustomerFiles;
